import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { useHistory, useLocation } from "react-router-dom";

import classes from "./PromotionalBanner.module.scss";
import { useModal } from "../../../hooks";
import { APPLICATION_ROUTES } from "../../../constants";
import Modal from "../Modal";
import Icon from "../../atoms/Icon";
import insideStoryImage from "../../../assets/images/inside-story.png";

// The promotion pops up once a session, a little after the page opens
const PROMO_SHOWN_KEY = "insideStoryPromoShown";
const PROMO_DELAY_MS = 2000;

const PromotionalBanner = observer(() => {
  const promoModal = useModal();
  const history = useHistory();
  const { pathname } = useLocation();

  // const handlePriceNoticeModal = () => {
  //   // priceNoticeModal.onOpen();
  //   history.push(`${APPLICATION_ROUTES.PARTNERS_MAIN_HOME}?scroll=true`);
  // }

  useEffect(() => {
    // It advertises the audio library, so not on the audio library itself
    if (!navigator.cookieEnabled || pathname === APPLICATION_ROUTES.AUDIO_LIBRARY) return undefined;
    if (window.sessionStorage.getItem(PROMO_SHOWN_KEY)) return undefined;

    const timeout = setTimeout(() => {
      window.sessionStorage.setItem(PROMO_SHOWN_KEY, true);
      promoModal.onOpen();
    }, PROMO_DELAY_MS);
    return () => clearTimeout(timeout);
  }, [pathname]);

  const onOpenAudioLibrary = () => {
    promoModal.onClose();
    history.push(APPLICATION_ROUTES.AUDIO_LIBRARY);
  };

  return (
    <>
      {/* <div
        onClick={handlePriceNoticeModal}
        className={cs(
          classes.container,
          isMobile
            ? classes.mobilePromotionalContainer
            : classes.desktopPromotionalContainer,
          "text-m-a"
        )}
      >
        {isMobile ? (
          <MobileView>
            <div className={classes.containerText}>
              <strong>SALE!</strong> 10% Yearly Subscription. <br /> <strong>NEW!</strong> Monthly subscription available.
            </div>
          </MobileView>
        ) : (
          <BrowserView>
            <div className={classes.containerText}>
            <strong>SALE!</strong> 10% Yearly Subscription. | <strong>NEW!</strong> Monthly subscription available.
            </div>
          </BrowserView>
        )}
      </div> */}
      <Modal opened={promoModal.isOpened} style={promoModal.style}>
        <div
          data-name="promo-modal-overlay"
          className={classes.promoOverlay}
          role="button"
          onClick={(event) => {
            if (event.target.matches(`[data-name="promo-modal-overlay"]`)) {
              promoModal.onClose();
            }
          }}
        >
          <div className={classes.posterCard}>
            <button className={classes.closeButton} onClick={promoModal.onClose} aria-label="Close">
              <Icon name="exit" size="m" />
            </button>
            <button className={classes.posterButton} onClick={onOpenAudioLibrary}>
              <img
                src={insideStoryImage}
                alt="Step inside the story: A Gutte Nacht with the Rebbe, the MyMaor bestseller, now in audio"
                className={classes.poster}
              />
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
});

export default PromotionalBanner;
